import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Application from './services/Application';
import 'react-complex-tree/lib/style-modern.css';
import { ConfigProvider } from 'antd';
import { COLORS, PRIMARY_COLOR } from './design/colors';
import MessageQueue from './services/MessageQueue';
import TokenManager from './services/TokenManager';
import Config from './services/Config';
import I18nService from './services/I18nService';
import initSentry from './services/Sentry';
import LocalStorageCleaner from './services/LocalStorageCleaner';
import UtmService from './services/UtmService';

// Clean up local storage if needed
LocalStorageCleaner.cleanStateIfNeeded();

initSentry();

Config.getConfig();
Application.init();
MessageQueue.init();
I18nService.init();
UtmService.init();
TokenManager.fetchToken()
  .then(() => {})
  .catch(() => {});

ReactDOM.createRoot(document.getElementById('root')!).render(
  //<React.StrictMode>
 <ConfigProvider
  theme={{
    token: {
      fontSize: 16,
      lineHeight: 1.5, // 16 * 1.5 = 24px
      colorPrimary: '#3498DB',
      colorLink: COLORS.color6,
    },
    components: {
      Button: {
        borderRadius: 50,
        fontSize: 16,
        lineHeight: 1.5,
        paddingBlock: 8, 
        paddingInline: 16, 
        boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.05)',   
      },

    },
  }}
>
  <App />
</ConfigProvider>
  //</React.StrictMode>
);
